import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveSipUserMutation = gql`
   mutation SaveSipUsers($sipUsers: [SipUserInput!]!) {
      saveSipUsers(sipUsers: $sipUsers) {
         sipUserId
         resetSipUserPassword
      }
   }
`;
